module.exports = __webpack_public_path__ + "img/feature_buy_ph.3dd7f281.png";